import axios from 'axios';
import { encode, decode } from 'js-base64';
import { store } from '../index';
import Config from '../constants/config';
import { logoutUser } from '../redux/auth/actions';
import SocketManager from '../SocketManager/SocketManager';
import { Manager } from '../StorageManager/Storage';
import history from "../utils/history";

export default class ApiManager {
    token = null;
    userName = null;
    sessionId = null;
    axiosInstance = null;
    static singleton = null;

    constructor() {
        axios.defaults.responseType = 'json';
        axios.defaults.baseURL = Config.et_api_url;
        axios.defaults.headers.put['Content-Type'] = 'application/json';
        // axios.defaults.headers.post['app-secret'] = 'Cx23R$W2M!';
        axios.defaults.headers.post['Content-Type'] = 'application/json';
    }

    static getInstance() {
        if (ApiManager.singleton == null) {
            ApiManager.singleton = new ApiManager();
        }
        return ApiManager.singleton;
    }

    setRequestOptions = (method, url, payload) => {
        let header =
            this.token === null
                ? { headers: { 'etSession': this.sessionId } }
                : {
                      auth: { username: this.userName, password: this.token },
                      headers: {
                          'etSession': this.sessionId,
                          'x-access-token': encode(
                              this.userName + ':' + this.token,
                          ),
                      },
                  };
        header['url'] = url;
        header['method'] = method;
        header['mode'] = 'cors';
        header['Access-Control-Allow-Origin'] = '*';
        if (method !== 'GET') {
            header['data'] = payload;
        } else {
            header['params'] = payload;
        }
        return header;
    };

    setSession = sessionId => {
        this.sessionId = sessionId.toString();
    };

    setToken = (email, token) => {
        this.token = token;
        this.userName = email;
    };

    send = (method, url, payload, type = "") => {
        return new Promise((resolve, reject) => {
            
            if(type == "installer") axios.defaults.baseURL = Config.installer_api_url;
            else axios.defaults.baseURL = Config.et_api_url;

            axios
                .request(this.setRequestOptions(method, url, payload))
                .then(response => {
                    console.log("response of api: ",response); 
                    if (response.data.code == 6054 || response.data.code == 6052) {
                        Manager.removeItem("sessionId");
                        Manager.removeItem("expireNotify");
                        let socket = SocketManager.getInstance();
                        socket.disconnect();
                        store.dispatch(logoutUser(history))
                    } else {
                        resolve(response)
                    }
                })
                .catch(error => reject(error));
        });
    };
}
